import { initFocusStyle } from './common/utils.js';
import initLoader from './common/macmillan.loader.js';

/**
 * Initializes the child gate functionality by setting up event listeners
 * and handling age verification logic. Depending on the selected age option,
 * it shows or hides billing and consent sections, displays an under-age message,
 * and enables or disables the payment button.
 */
const initChildGate = () => {
    const $childGate = $('.child-gate');

    if ($childGate.length > 0) {

        const $ageOption1 = $childGate.find('#ageOption1');
        const $ageOption2 = $childGate.find('#ageOption2');
        const $ageOption3 = $childGate.find('#ageOption3');
        const $underAgeMessage = $childGate.find('.under-age');
        const $billing = $('.billing');
        const $consent = $('.consent');
        const $btnContainer = $('.btn-container');
        const $paymentButton = $btnContainer.find('button').first();

        $(window).on('load', function () {
            ageGateRadioEvents();
        })

        $childGate.on('click', function () {
            ageGateRadioEvents();
        })

        function ageGateRadioEvents() {
            if ($ageOption1.is(':checked')) {
                $billing.show();
                $consent.show();
                $underAgeMessage.hide();
                $paymentButton.prop('disabled', false);
            }

            if ($ageOption2.is(':checked')) {
                $billing.show();
                $consent.hide();
                $underAgeMessage.hide();
                $paymentButton.prop('disabled', false);
                $consent.find('input').prop('checked', false);
            }

            if ($ageOption3.is(':checked')) {
                $billing.hide();
                $consent.hide();
                $underAgeMessage.show();
                $paymentButton.prop('disabled', true);
                $billing.find('input').val('');
                $consent.find('input').prop('checked', false);
            }
        }
    }
}

/**
 * Initializes custom dropdown menus using native select elements with vanilla JavaScript.
 * 
 * jQuery UI selectmenu widget has been removed. This function now:
 * - Removes placeholder class on selection
 * - Handles "Other" relation visibility
 * - Triggers validation if jQuery validator is available
 * All styling is handled via CSS instead of JavaScript.
 */
const initCustomDropdowns = () => {
    const selects = document.querySelectorAll('.js-dropdown select');
    
    selects.forEach(select => {
        select.addEventListener('change', (e) => {
            // Remove placeholder class when selection changes
            e.target.parentElement.classList.remove('placeholder');
            
            // Handle "Other" relation visibility
            if (e.target.value === "Other") {
                document.querySelectorAll('.otherRelation').forEach(el => {
                    el.style.display = '';
                });
            } else {
                document.querySelectorAll('.otherRelation').forEach(el => {
                    el.style.display = 'none';
                });
            }
            
            // Trigger validation if jQuery validator exists
            if (typeof $ !== 'undefined' && $.fn.valid) {
                $(e.target).valid();
            }
        });
    });
}

/**
 * Initializes an event listener that prevents the default action
 * and stops propagation for click events on elements with the 'disabled' class.
 */
const initPreventDefaultOnDisabled = () => {
    $('.disabled').on('click', function (e) {
        e.preventDefault();
        return false;
    });
}

export const initDonations = () => {
    // Initial setup
    initChildGate();
    initFocusStyle();
    initCustomDropdowns();
    initPreventDefaultOnDisabled();
    
    // Run a function when the page is fully loaded including graphics.
    $(window).on('load', function () {
        // When element specified with 'js-show-loader' class is clicked
        // then check for payment form type and initiate loader
        $(".js-show-loader").on("click", function () {
            // Check the form element closest to the clicked element
            // and later check if it is valid inside initLoader function
            const macmillanForm = $(this).closest("form");
    
            // Initiate loader
            initLoader(macmillanForm);
        });
    });
};
